/**
 * Kick the API as soon as the main bundle runs, before React mounts.
 * After a cold browser restore the first real call is often /auth/me; starting
 * TLS + a cheap health check here hides Render/API wake time behind JS parse.
 */
const backend = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");

if (backend && typeof fetch === "function") {
  fetch(`${backend}/api/health`, {
    cache: "no-store",
    credentials: "omit",
    mode: "cors",
  }).catch(() => {});
}
